/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React from "react";
import styles from "./styles.module.scss";
import Image from "next/image";

export default function CompanyStats() {
  const statsData = [
    {
      id: 1,
      numbers: "20 Lakhs",
      subtitle: "Learners",
      icon: "assets/landing/solid_friends.webp",
    },
    {
      id: 2,
      numbers: "3000+",
      subtitle: "Videos",
      icon: "assets/landing/zondicons_film.webp",
    },
    {
      id: 3,
      numbers: "3.5 Crore",
      subtitle: "Minutes watched",
      icon: "assets/landing/mdi_eye.webp",
    },
  ];
  return (
    <div className={styles.companystats_wrapper}>
      {statsData?.map((data, index) => (
        <div className={styles.stats_listing} key={index}>
          <div className={styles.icons}>
            <img alt="seekho" src={data.icon} className={styles.icons_small} />
          </div>
          <div className={styles.stats_data}>
            <span className={styles.stats_data_number}>{data.numbers}</span>
            <span className={styles.stats_data_title}>{data.subtitle}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
